import { i18n } from '@/i18n/index'
import { globalize } from './globalize'

export function formatUserRole (value) {
  if (!value) return '-'
  const globalization = `user-role.lbl-${value}`
  if (i18n.exists(globalization)) {
    return globalize(globalization)
  }
  return value
}
